import { render, staticRenderFns } from "../../components/shared/contacts/NewContactTemplate.html?vue&type=template&id=8370ded4&scoped=true&"
import script from "./NewContactModal.vue?vue&type=script&lang=js&"
export * from "./NewContactModal.vue?vue&type=script&lang=js&"
import style0 from "./NewContactModal.vue?vue&type=style&index=0&id=8370ded4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8370ded4",
  null
  
)

component.options.__file = "NewContactModal.vue"
export default component.exports